module.exports = __webpack_public_path__ + "static/media/spring.a9529e42.svg";